/* global Editor */

window.Editor = {}

let implementation = null

Editor.load = function () {
  if (!implementation) {
    implementation = import('lib/editor_impl').catch((error) => {
      implementation = null
      throw error
    })
  }

  return implementation
}

Editor.initEditor = function (element) {
  if (!$('.code-editor, .editor', element).length) return Promise.resolve()

  return Editor.load().then((impl) => impl.initEditor(element))
}

Editor.initTextEditor = function (element, additionalParams) {
  return Editor.load().then((impl) => impl.initTextEditor(element, additionalParams))
}

Editor.initCodeEditor = function (element, additionalParams) {
  return Editor.load().then((impl) => impl.initCodeEditor(element, additionalParams))
}

Editor.whenReady = function (element) {
  return Editor.load().then(() => $(element).data('editor'))
}

Editor.getValue = function (element) {
  const $element = $(element)
  const editor = $element.data('editor')

  return editor ? editor.value : $element.val()
}

Editor.setValue = function (element, value) {
  const $element = $(element)
  const editor = $element.data('editor')

  if (editor) editor.value = value
  else $element.val(value)
}

Editor.checkValidity = (editor) => {
  const SKILLS_LINK = 'skills_link'
  const TP_CONFIRM_LINK = 'tp_confirm_link'
  const ASSESSMENT_LINK = 'assessment_link'
  const JOB_AD_LINK = 'job_ad_link'
  const TERMS_LINK = 'terms_link'
  const LIQUID_TAG_REGEX = new RegExp(`{%\\s?(${TP_CONFIRM_LINK}|${SKILLS_LINK}|${ASSESSMENT_LINK}|${JOB_AD_LINK}|${TERMS_LINK}| \[(.+)\])\\s[^\"]+\\s?%}`, 'g')
  const content = editor.value
  let valid = true
  let error = ''
  // Error if there are unclosed tags in email body
  if (content.search(/{%/g) !== -1) { valid = content.match(/{%/g).length === (content.match(LIQUID_TAG_REGEX) && content.match(LIQUID_TAG_REGEX).length) }
  if (!valid) error = I18n.t('mailers.tags_error')

  $(editor.container).toggleClass('has-error', !valid)
  $('#email-body-error').text(error)
  return valid
}

